import { useState } from 'react'
import { ResolucaoDetalhada } from '../types'
import { reprocessarCenarios } from './lotesRepository'

export interface ErroCenarios {
  status?: number
  message: string
}

export function useCenariosResolvidos(loteId: string) {
  const [loading, setLoading] = useState(false)
  const [resolucao, setResolucao] = useState<ResolucaoDetalhada | null>(null)
  const [erro, setErro] = useState<ErroCenarios | null>(null)

  async function reprocessar() {
    setLoading(true)
    setErro(null)

    try {
      const response = await reprocessarCenarios(loteId)

      if (response.ok && response.data) {
        setResolucao(response.data)
      } else {
        // Sem toast genérico: o 409 (empate de cenários) é um problema de cadastro que o usuário precisa entender.
        setResolucao(null)
        setErro({
          status: response.status,
          message:
            (response.data as ApiErrorResponse | undefined)?.message ??
            'Não foi possível reprocessar os cenários.'
        })
      }
    } finally {
      setLoading(false)
    }
  }

  return { loading, resolucao, erro, reprocessar }
}
